module.exports = __webpack_public_path__ + "static/media/no_feedback.39fd28a3.svg";